export default "__VITE_ASSET__c860c2ab__"